export const UI_CONST = {
    modalId: "#mng-modal",
    modalTitleId: "#mng-modal-title",
    modalBodyId: "#mng-modal-body",
    modalClose: '.mng-modal-close',
    screenBody: '.mng-screen-body',
    screenTitle: '.mng-screen-title',
    alertSection: '.mng-alert-section',
    authSocialAction: '[data-mng-auth-social-action]',
    authActionShowScreen: '[data-mng-auth-show-screen]',
    authActionLogout: '[data-mng-auth-action="logout"]',
    authActionLogin: '[data-mng-auth-action="login"], .log-in-button',
    authActionRegister: '[data-mng-auth-action="register"]',
    authActionLoginPS: '[data-login-btn="true"]',
    authActionLogoutPS: '[data-logout-btn="true"]',
    authActionLoginCxt: '[data-mng-cta="Login"]',
    authActionLogoutCxt: '[data-mng-cta="Logout"]',
    formSelector: '.mng-auth-form',
}